import React, {useState} from 'react';
import './App.css';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import {observer} from 'mobx-react';
import Logger from './lib/Logger';
import Box from './Common/Box';
import ThemeProvider from './lib/theme/components/ThemeProvider';

//@todo fix this
import uiStore from './lib/stores/uiStore';
import AppManager from './AppManager/AppManager';
import {AppManagerContext} from './Common/Contexts';
import ManagerToggle from './AppManager/ManagerToggle';
import {BrowserRouter as Router} from 'react-router-dom';
import {IConfiguration} from "./configuration";
import {WebGLRenderer} from "three";

const logger = new Logger("App");

interface AppProps {
    configuration: IConfiguration
}

export default observer(function App({configuration}: AppProps) {

    const {
        prefix: appKey,
        defaultTheme,
        alternateTheme,
        component: Component,
        withThemeSelect,
    } = configuration;

    React.useEffect(() => {
        setTimeout(() => {

            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register('/service-worker.js').then(function (registration) {
                    logger.log('ServiceWorker registration successful with scope: ', registration.scope);
                }, function (err) {
                    logger.error('ServiceWorker registration failed: ', err);
                });

            }
        }, 3000)
    }, [])


    const [renderers, setRenderers] = useState<WebGLRenderer[]>([]);

    const toggleAppManager = () => {
        uiStore.appManagerEnabled = !uiStore.appManagerEnabled;
        logger.trace("toggling app manager: " + uiStore.appManagerEnabled);
    };

    window.toggleAppManager = toggleAppManager


    const managerEnabled = uiStore.appManagerEnabled;


    return <StyledEngineProvider injectFirst>

        <Router
                //@todo needed?
                // history={history}
        >
            <Box
                    style={{
                        position: "fixed",
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}
            >
                <AppManagerContext.Provider value={{toggleAppManager, managerEnabled, renderers, setRenderers}}>
                    <ThemeProvider
                            withThemeSelect={withThemeSelect}
                            appKey={appKey}
                            // theme={theme}
                            defaultTheme={defaultTheme}
                            alternateTheme={alternateTheme}
                    >
                        <ManagerToggle/>
                        <Component/>

                        {uiStore.appManagerEnabled && <AppManager/>}
                    </ThemeProvider>
                </AppManagerContext.Provider>
            </Box>
        </Router>
    </StyledEngineProvider>
})

